'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchDocument = exports.fetchDocuments = undefined;

var _prismicJavascript = require('prismic-javascript');

var _prismicJavascript2 = _interopRequireDefault(_prismicJavascript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var buildPredicates = function buildPredicates(type) {
  var predicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return type ? [_prismicJavascript.Predicates.at('document.type', type)].concat(_toConsumableArray(predicates)) : predicates;
};

var fetchDocuments = exports.fetchDocuments = function fetchDocuments(_ref) {
  var _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === undefined ? 20 : _ref$pageSize,
      predicates = _ref.predicates,
      repository = _ref.repository,
      token = _ref.token,
      type = _ref.type;
  return _prismicJavascript2.default.getApi('https://' + repository + '.cdn.prismic.io/api/v2').then(function (api) {
    return api.everything().ref(token || api.master()).query(buildPredicates(type, predicates), {}).pageSize(pageSize).submit();
  }).then(function (response) {
    return response.results;
  });
};

var fetchDocument = exports.fetchDocument = function fetchDocument(params) {
  return fetchDocuments(params).then(function (results) {
    return results[0];
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/fetch/index.js
// module id = 477
// module chunks = 0